export const getIsFirstPartOfDateTypeMonth = (date_format: "MM/DD/YYYY" | "DD/MM/YYYY" | "YYYY/MM/DD") => {
  switch (date_format) {
    case "MM/DD/YYYY":
      return true
    case "DD/MM/YYYY":
      return false
    case "YYYY/MM/DD":
      return true
    default:
      return true
  }
}
